export const getCachedSettings = (hash) => {
  const cached = localStorage.getItem(`healthySignalsSettings_${hash}`)
  return cached ? JSON.parse(cached) : null
}

export const getCachedPerson = (hash) => {
  const cached = localStorage.getItem(`healthySignalsPerson_${hash}`)
  return cached ? JSON.parse(cached) : null
}

export const setCachedSettings = (hash, data) => {
  localStorage.setItem(`healthySignalsSettings_${hash}`, JSON.stringify(data))
}

export const setCachedPerson = (hash, data) => {
  localStorage.setItem(`healthySignalsPerson_${hash}`, JSON.stringify(data))
}

export const clearHealthySignalsCache = (hash) => {
  // Clear all healthy signals caches for this hash
  const keysToRemove = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (
      key &&
      (key.includes(`healthySignalsSettings_${hash}`) ||
        key.includes(`healthySignalsPerson_${hash}`))
    ) {
      keysToRemove.push(key)
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key))
}
